<template>
  <div class="p-4 border rounded bg-gray-50 shadow text-sm space-y-2">
    <h3 class="font-bold mb-2">Meta CAPI Debug</h3>
    <p><strong>_fbp:</strong> {{ fbp }}</p>
    <p><strong>_fbc:</strong> {{ fbc }}</p>
    <p><strong>Email:</strong> {{ email }}</p>
    <p><strong>SHA256:</strong> {{ emailHash }}</p>

    <button
      @click="sendTestEvent"
      class="mt-3 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
    >
      Test senden
    </button>

    <p v-if="status" class="mt-2">
      <strong>Status:</strong> {{ status }}
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { getFbpFromCookie, getFbcFromCookie, hashUserData } from "@/lib/helper/facebook";

const fbp = ref("");
const fbc = ref("");
const email = ref("test@example.com");
const emailHash = ref("");
const status = ref("");

onMounted(async () => {
  fbp.value = getFbpFromCookie();
  fbc.value = getFbcFromCookie();
  const hash = await hashUserData({ email: email.value });
  emailHash.value = hash.email;
});

async function sendTestEvent() {
  const meta = {
    fbp: fbp.value,
    fbc: fbc.value,
    test_event_code: "TEST123ABC",
    ...(await hashUserData({ email: email.value }))
  };

  const ecommerce = {
    transaction_id: "MOLS-DEMO-001",
    value: 199.99,
    currency: "EUR"
  };

  const body = {
    event_name: "purchase",
    client_id: "555.123456",
    user_id: "td-dev-user",
    ecommerce,
    meta
  };

  try {
    const res = await fetch("http://localhost:8787", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    });

    const responseText = await res.text();
    status.value = `Response ${res.status}: ${responseText}`;
  } catch (err) {
    status.value = "Fehler: " + err.message;
  }
}
</script>
